module.exports = __webpack_public_path__ + "static/media/socicon.944f06f5.woff";